

export class AssessmentMethod {
  assessmentMethodId: string;
  assessmentMethodName: string;
}
